import { render, staticRenderFns } from "./SafetyHistoryList.vue?vue&type=template&id=2a1bffa0&scoped=true&"
import script from "./SafetyHistoryList.vue?vue&type=script&lang=js&"
export * from "./SafetyHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./SafetyHistoryList.vue?vue&type=style&index=0&id=2a1bffa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1bffa0",
  null
  
)

export default component.exports